import type { Todo } from '../notifications/useTodos';

/**
 * Trim the shared to-do list to what's relevant on the MANAGER dashboard.
 * Expense / Invoice / Credit-card approvals are finance/admin work, not team-
 * manager work — they still appear in the notification bell for approvers, just
 * not here (or in the My Team badge).
 */
const EXCLUDED_TOOLS = new Set(['Expenses', 'Invoices', 'Credit Cards']);

export function managerTodos(todos: Todo[]): Todo[] {
  return todos.filter((t) => !EXCLUDED_TOOLS.has(t.tool));
}
